import { render } from "./BillDetailModal.vue?vue&type=template&id=72f8afb6"
import script from "./BillDetailModal.vue?vue&type=script&lang=js"
export * from "./BillDetailModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__